import { Deserializable } from '../deserializable';

export class AdvisedKfiDto implements Deserializable {
  public EntityNumberAsHash: string;
  public EntityNumber?: number;
  public RecommendationNumber?: number;
  public ProductName: string;
  public BorrowingTermYears?: number;
  public BorrowingTermMonths?: number;
  public LTV?: number;
  public StatusCode: string;
  public LoanAmount?: number;
  public ServiceLevel: string;
  public CreatedDate?: Date;
  public CreatedBy: string;
  public ApplicationNumber?: number;
  public ApplicationID: string;
  public ApplicationTypeCode: string;
  public Reason: string;
  public ArtefactIdWithPdfBundle: string;
  public CanBeAccepted: boolean;
  public AllowsExpiredProduct: boolean;
  public IsRecommendedCode: string;
  public KfiNumber: number;
  public KfiNumberAsHash: string;
  public IsProductActive: boolean;
  public ApplicantsNames: string;
  public IsRecommendationBundleAvailable: boolean;
  public WasIllustrationReplaced: boolean;
  public IsOverrideIllustrationRequired: boolean;
  public IllustrationStatusCode: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
